var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnableDisableFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.199707 3.3C0.199707 1.47747 1.67717 0 3.49971 0H14.4997C16.3223 0 17.7997 1.47747 17.7997 3.3V6.6C17.7997 8.42259 16.3223 9.9 14.4997 9.9H3.49971C1.67717 9.9 0.199707 8.42259 0.199707 6.6V3.3ZM3.49971 1.1C2.28468 1.1 1.29971 2.08497 1.29971 3.3V6.6C1.29971 7.81506 2.28468 8.8 3.49971 8.8H14.4997C15.7148 8.8 16.6997 7.81506 16.6997 6.6V3.3C16.6997 2.08497 15.7148 1.1 14.4997 1.1H3.49971ZM7.89971 4.95C7.89971 4.64625 8.14595 4.4 8.44971 4.4H13.3997C13.7034 4.4 13.9497 4.64625 13.9497 4.95C13.9497 5.25375 13.7034 5.5 13.3997 5.5H8.44971C8.14595 5.5 7.89971 5.25375 7.89971 4.95ZM6.79971 4.95C6.79971 5.86124 6.06098 6.6 5.14971 6.6C4.23843 6.6 3.49971 5.86124 3.49971 4.95C3.49971 4.03873 4.23843 3.3 5.14971 3.3C6.06098 3.3 6.79971 4.03873 6.79971 4.95Z",
    fill: "#0076FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableDisableFeatures);
export default __webpack_public_path__ + "static/media/enable-disable-features.229af42c08ece2055dc94dac5c48f1f1.svg";
export { ForwardRef as ReactComponent };